/* MyScrubs — Arma tu conjunto v2 (29-oct-2026)
   Top y pantalón con color, talla y largo elegidos POR SEPARADO, con el mismo marcado de la ficha
   (Dawn: swatch-input circular para color, píldoras para talla).
   Ayuda: el pantalón parte en el color del top y lo sigue mientras el cliente no le elija otro.
   Agrega 2 líneas normales con /cart/add.js y abre el cart drawer. */
(function () {
  if (customElements.get('ms-conjunto')) return;

  var fmt = function (cents) {
    return '$' + Math.round(cents / 100).toLocaleString('es-CL');
  };
  var norm = function (s) { return String(s || '').trim().toLowerCase(); };
  var esc = function (s) { return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;'); };

  class MsConjunto extends HTMLElement {
    connectedCallback() {
      var raw = this.querySelector('[data-ms-conj-data]');
      if (!raw || this._ok) return;
      try { this.data = JSON.parse(raw.textContent); } catch (e) { console.error('[ms-conjunto] JSON', e); return; }
      this._ok = true;
      this.uid = this.dataset.section || 'c';

      this.piezas = this.data.piezas.map(function (pz) {
        return { rol: pz.rol, rolLabel: pz.rolLabel, productos: pz.largos, prod: pz.largos[0], color: null, talla: null, colorManual: false, el: null };
      });

      this.$precio = this.querySelector('[data-ms-precio]');
      this.$cta = this.querySelector('[data-ms-cta]');
      this.$ctaTxt = this.querySelector('[data-ms-cta-texto]');
      this.$err = this.querySelector('[data-ms-error]');

      var self = this, top = this.piezas[0], pant = this.piezas[1];
      var urlColor = new URLSearchParams(location.search).get('color');
      // 30-oct-2026: sin ?color= se parte en el color de portada (Negro, como FIGS) si tiene stock.
      var cPortada = this.dataset.colorPortada;
      if (!(this.tieneColor(top.prod, urlColor) && this.hayStock(top.prod, urlColor))) urlColor = null;
      if (!urlColor && this.tieneColor(top.prod, cPortada) && this.hayStock(top.prod, cPortada)) urlColor = cPortada;
      top.color = urlColor ? this.nombreColor(top.prod, urlColor) : this.primerColorDisponible(top.prod);
      pant.color = this.colorSeguidor(pant, top.color);

      this.montarPiezas();
      this.$cta.addEventListener('click', function () { self.agregar(); });
      this.montarModal();
      this.render();
    }

    /* ---------- datos ---------- */
    // 04-nov-2026: "Ver los detalles" abre un popup (como FIGS) en vez de otra pestaña.
    montarModal() {
      var self = this, sec = this.closest('.shopify-section') || document;
      this.$modal = sec.querySelector('[data-ms-modal]') || document.querySelector('[data-ms-modal]');
      if (!this.$modal || typeof this.$modal.showModal !== 'function') return; // sin <dialog>: el link sigue llevando a la ficha
      var m = this.$modal;
      var cerrar = function () { m.close(); };
      m.querySelector('[data-m-cerrar]').addEventListener('click', cerrar);
      m.addEventListener('click', function (e) { if (e.target === m) cerrar(); }); // clic en el fondo
      m.addEventListener('close', function () { document.body.classList.remove('ms-modal-abierto'); if (self._volverA) self._volverA.focus(); });
      this.addEventListener('click', function (e) {
        var a = e.target.closest('[data-detalle],[data-guia]');
        if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return; // ctrl/cmd-clic sigue abriendo pestaña
        var pz = self.piezas.find(function (p) { return p.el && p.el.contains(a); });
        if (!pz) return;
        var esGuia = a.hasAttribute('data-guia');
        if (esGuia && !pz.prod.guiaHtml) return; // sin contenido: deja el link a la página
        e.preventDefault();
        self._volverA = a;
        if (esGuia) self.abrirGuia(pz); else self.abrirModal(pz);
      });
    }
    modo(guia) {
      this.$modal.querySelector('[data-m-guia]').hidden = !guia;
      this.$modal.querySelector('[data-m-grid]').hidden = guia;
    }
    abrirGuia(pz) {
      var m = this.$modal;
      this.modo(true);
      m.querySelector('[data-m-guia-prod]').textContent = pz.prod.titulo;
      m.querySelector('[data-m-guia-body]').innerHTML = pz.prod.guiaHtml; // contenido de la página de la guía (Shopify)
      document.body.classList.add('ms-modal-abierto');
      m.showModal();
      m.scrollTop = 0;
    }
    abrirModal(pz) {
      var m = this.$modal, prod = pz.prod, f = prod.ficha || {};
      this.modo(false);
      var url = prod.url + (pz.color ? '?color=' + encodeURIComponent(pz.color) : '');
      var fotos = this.fotosColor(prod, pz.color);
      var img = fotos[0] || this.imgDe(pz) || prod.img;
      var im = m.querySelector('[data-m-img]');
      im.src = img || ''; im.srcset = img ? this.srcset(img) : ''; im.sizes = '(min-width:750px) 440px, 90vw';
      im.alt = prod.titulo + (pz.color ? ' ' + pz.color : '');
      m.querySelector('[data-m-titulo]').textContent = prod.titulo;
      m.querySelector('[data-m-ver]').href = url;
      var filas = [['Ajuste', f.ajuste], ['Corte', f.corte], ['Cuello', f.cuello], ['Bolsillos', f.bolsillos], ['Medida', f.medida]]
        .filter(function (x) { return x[1] != null && x[1] !== ''; });
      var dl = filas.length ? '<dl class="ms-conj__ficha">' + filas.map(function (x) { return '<dt>' + esc(x[0]) + '</dt><dd>' + esc(x[1]) + '</dd>'; }).join('') + '</dl>' : '';
      var det = m.querySelector('[data-m-det]');
      det.querySelector('[data-m-det-body]').innerHTML = dl + (prod.desc || ''); // desc = descripción del producto (HTML de Shopify)
      det.hidden = !(dl || prod.desc);
      det.open = true;
      var tela = m.querySelector('[data-m-tela]');
      tela.querySelector('[data-m-tela-body]').innerHTML = f.composicion ? '<p>' + esc(f.composicion) + '</p>' : '';
      tela.hidden = !f.composicion;
      tela.open = false;
      var mas = m.querySelector('[data-m-mas]'), cols = prod.colecciones || [];
      m.querySelector('[data-m-mas-links]').innerHTML = cols.map(function (c) { return '<a href="' + esc(c.u) + '">' + esc(c.t) + '</a>'; }).join('');
      mas.hidden = !cols.length;
      document.body.classList.add('ms-modal-abierto');
      m.showModal();
      m.scrollTop = 0;
    }
    tieneColor(prod, c) { return !!c && prod.colores.some(function (x) { return norm(x.nombre) === norm(c); }); }
    nombreColor(prod, c) { var x = prod.colores.find(function (x) { return norm(x.nombre) === norm(c); }); return x ? x.nombre : null; }
    hayStock(prod, color) { return prod.variantes.some(function (v) { return norm(v.c) === norm(color) && v.ok; }); }
    primerColorDisponible(prod) {
      var self = this, c = prod.colores.find(function (c) { return self.hayStock(prod, c.nombre); });
      return (c || prod.colores[0] || {}).nombre || null;
    }
    // color que toma el pantalón cuando sigue al top
    colorSeguidor(pz, colorTop) {
      if (this.tieneColor(pz.prod, colorTop) && this.hayStock(pz.prod, colorTop)) return this.nombreColor(pz.prod, colorTop);
      return pz.color && this.tieneColor(pz.prod, pz.color) ? pz.color : this.primerColorDisponible(pz.prod);
    }
    variante(pz) {
      if (!pz.color || !pz.talla) return null;
      return pz.prod.variantes.find(function (v) { return norm(v.c) === norm(pz.color) && norm(v.t) === norm(pz.talla); }) || null;
    }
    imgDe(pz) {
      var v = pz.prod.variantes.find(function (v) { return norm(v.c) === norm(pz.color) && v.img; });
      return (v && v.img) || pz.prod.img;
    }
    ajustarTalla(pz) {
      if (!pz.talla) return;
      var v = this.variante(pz);
      if (!v || !v.ok) pz.talla = null; // no existe o está agotada en el color nuevo
    }

    /* ---------- montaje ---------- */
    montarPiezas() {
      var tpl = document.querySelector('[data-ms-tpl-pieza]');
      var cont = this.querySelector('[data-ms-piezas]');
      var self = this;
      this.piezas.forEach(function (pz, i) {
        var frag = tpl.content.cloneNode(true);
        var el = frag.querySelector('[data-pieza]');
        el.dataset.rol = pz.rol;
        pz.el = el;
        el.querySelector('[data-rol]').textContent = pz.rolLabel;
        cont.appendChild(frag);

        el.addEventListener('change', function (e) {
          var t = e.target;
          if (t.dataset.color != null) {
            pz.color = t.dataset.color;
            pz.colorManual = true;
            self.ajustarTalla(pz);
            if (i === 0) { // el pantalón sigue al top mientras no lo hayan tocado
              var p2 = self.piezas[1];
              if (!p2.colorManual) { p2.color = self.colorSeguidor(p2, pz.color); self.ajustarTalla(p2); }
            }
          } else if (t.dataset.talla != null) {
            pz.talla = t.dataset.talla;
          } else if (t.dataset.largo != null) {
            var nuevo = pz.productos.find(function (p) { return String(p.id) === t.dataset.largo; });
            if (nuevo) {
              pz.prod = nuevo;
              if (!self.tieneColor(nuevo, pz.color)) pz.color = self.primerColorDisponible(nuevo);
              else pz.color = self.nombreColor(nuevo, pz.color);
              self.ajustarTalla(pz);
            }
          }
          self.render();
        });
      });
    }

    /* ---------- render ---------- */
    swatchesHTML(pz) {
      var self = this, base = this.uid + '-' + pz.rol + '-c';
      return pz.prod.colores.map(function (c, k) {
        var agotado = !self.hayStock(pz.prod, c.nombre);
        var id = base + k;
        var sel = norm(c.nombre) === norm(pz.color);
        var bg = c.sw ? 'style="--swatch--background: ' + c.sw + ';"' : '';
        return '<input type="radio" id="' + id + '" name="' + base + '" value="' + esc(c.nombre) + '" data-color="' + esc(c.nombre) + '"' +
          ' class="swatch-input__input' + (agotado ? ' visually-disabled' : '') + '"' + (sel ? ' checked' : '') + '>' +
          '<label for="' + id + '" title="' + esc(c.nombre) + '" class="swatch-input__label">' +
          '<span class="swatch' + (c.sw ? '' : ' swatch--unavailable') + '" ' + bg + '></span>' +
          '<span class="visually-hidden">' + esc(c.nombre) + (agotado ? ' (agotado)' : '') + '</span></label>';
      }).join('');
    }
    pillsHTML(nombre, items) {
      // items: [{valor, label, checked, disabled, attr}]
      return items.map(function (it, k) {
        var id = nombre + '-' + k;
        return '<input type="radio" id="' + id + '" name="' + nombre + '" value="' + esc(it.valor) + '" ' + it.attr + '="' + esc(it.valor) + '"' +
          (it.checked ? ' checked' : '') + (it.disabled ? ' disabled class="disabled"' : '') + '>' +
          '<label for="' + id + '">' + esc(it.label) + (it.disabled ? '<span class="visually-hidden label-unavailable"> agotada</span>' : '') + '</label>';
      }).join('');
    }
    reemplazarInputs(fieldset, html) {
      Array.prototype.slice.call(fieldset.children).forEach(function (n) { if (n.tagName !== 'LEGEND') n.remove(); });
      fieldset.insertAdjacentHTML('beforeend', html);
    }

    render() {
      var self = this;
      this.piezas.forEach(function (pz) {
        var el = pz.el, prod = pz.prod;
        var img = self.imgDe(pz);
        var th = el.querySelector('[data-thumb]');
        if (img) th.src = img.replace(/width=\d+/, 'width=160');
        th.alt = prod.titulo;
        el.querySelector('[data-nombre]').textContent = prod.titulo;
        el.querySelector('[data-detalle]').href = prod.url + (pz.color ? '?color=' + encodeURIComponent(pz.color) : '');
        var est = el.querySelector('[data-estrellas]');
        if (prod.rating && prod.ratingCount) { est.hidden = false; est.textContent = '★ ' + Number(prod.rating).toFixed(1) + ' (' + prod.ratingCount + ' reseñas)'; } else est.hidden = true;
        var guia = el.querySelector('[data-guia]');
        if (prod.guia) { guia.hidden = false; guia.href = prod.guia; } else guia.hidden = true;

        // color
        var fsC = el.querySelector('[data-swatches]');
        fsC.querySelector('[data-color-nombre]').textContent = pz.color || '';
        self.reemplazarInputs(fsC, self.swatchesHTML(pz));

        // tallas del color activo
        var fsT = el.querySelector('[data-tallas]');
        self.reemplazarInputs(fsT, self.pillsHTML(self.uid + '-' + pz.rol + '-t', prod.tallas.map(function (t) {
          var v = prod.variantes.find(function (v) { return norm(v.c) === norm(pz.color) && norm(v.t) === norm(t); });
          return { valor: t, label: t, checked: norm(pz.talla) === norm(t), disabled: !(v && v.ok), attr: 'data-talla' };
        })));

        // largos (Regular / Tall) si el producto tiene enlazado custom.largos
        var fsL = el.querySelector('[data-largos]');
        if (pz.productos.length > 1) {
          fsL.hidden = false;
          fsL.querySelector('[data-largo-nombre]').textContent = prod.largo;
          self.reemplazarInputs(fsL, self.pillsHTML(self.uid + '-' + pz.rol + '-l', pz.productos.map(function (p) {
            return { valor: String(p.id), label: p.largo, checked: p === prod, disabled: false, attr: 'data-largo' };
          })));
        } else fsL.hidden = true;

      });
      this.renderGaleria();
      this.renderPrecio();
      this.renderCTA();
    }

    /* ---------- galería (estilo FIGS) ---------- */
    // fotos del producto para un color: el alt de la foto es el nombre del color
    fotosColor(prod, color) {
      return (prod.media || []).filter(function (m) { return norm(m.a) === norm(color); }).map(function (m) { return m.u; });
    }
    srcset(u) {
      if (!u) return '';
      return [360, 540, 720, 900, 1100].map(function (w) { return u.replace(/width=\d+/, 'width=' + w) + ' ' + w + 'w'; }).join(', ');
    }
    renderGaleria() {
      var self = this, top = this.piezas[0], pant = this.piezas[1];
      var clave = top.prod.id + ':' + top.color + '|' + pant.prod.id + ':' + pant.color;
      if (this._galClave === clave) return;
      this._galClave = clave;

      var imgTop = this.imgDe(top), imgPant = this.imgDe(pant);
      var slides = [{ par: true, top: imgTop, pant: imgPant }];
      // la misma foto puede venir en distintos tamaños (width=900 / 1100): se compara sin el querystring
      var base = function (u) { return String(u || '').split('?')[0]; };
      var vistos = {}; vistos[base(imgTop)] = 1; vistos[base(imgPant)] = 1;
      var add = function (u, alt) { if (u && !vistos[base(u)]) { vistos[base(u)] = 1; slides.push({ u: u, alt: alt }); } };
      this.fotosColor(top.prod, top.color).forEach(function (u) { add(u, top.prod.titulo + ' ' + top.color); });
      this.fotosColor(pant.prod, pant.color).forEach(function (u) { add(u, pant.prod.titulo + ' ' + pant.color); });
      (this.data.fotos || []).forEach(function (u) { add(u, 'Conjunto puesto'); });
      this.slides = slides;

      var track = this.querySelector('[data-ms-track]');
      var thumbs = this.querySelector('[data-ms-thumbs]');
      var sizes = '(min-width: 990px) 50vw, 100vw';
      track.innerHTML = slides.map(function (s, i) {
        if (s.par) {
          return '<div class="ms-conj__slide ms-conj__slide--par">' +
            '<figure class="ms-conj__fig"><img src="' + esc(s.top || '') + '" srcset="' + esc(self.srcset(s.top)) + '" sizes="(min-width: 990px) 25vw, 50vw" alt="' + esc(top.prod.titulo + ' ' + top.color) + '"' + (i ? ' loading="lazy"' : '') + '></figure>' +
            '<figure class="ms-conj__fig"><img src="' + esc(s.pant || '') + '" srcset="' + esc(self.srcset(s.pant)) + '" sizes="(min-width: 990px) 25vw, 50vw" alt="' + esc(pant.prod.titulo + ' ' + pant.color) + '"></figure></div>';
        }
        return '<figure class="ms-conj__slide"><img src="' + esc(s.u) + '" srcset="' + esc(self.srcset(s.u)) + '" sizes="' + sizes + '" alt="' + esc(s.alt) + '" loading="lazy"></figure>';
      }).join('');
      var mini = function (u) { return esc((u || '').replace(/width=\d+/, 'width=200')); };
      thumbs.innerHTML = slides.map(function (s, i) {
        var inner = s.par ? '<img src="' + mini(s.top) + '" alt="" loading="lazy"><img src="' + mini(s.pant) + '" alt="" loading="lazy">'
                          : '<img src="' + mini(s.u) + '" alt="" loading="lazy">';
        return '<button type="button" class="ms-conj__thumb-btn' + (s.par ? ' ms-conj__thumb-btn--par' : '') + '" data-ms-ir="' + i + '" aria-label="Ver foto ' + (i + 1) + ' de ' + slides.length + '"' + (i === 0 ? ' aria-current="true"' : '') + '>' + inner + '</button>';
      }).join('');
      track.scrollLeft = 0;
      this.marcarSlide(0);

      if (!this._galEventos) {
        this._galEventos = true;
        thumbs.addEventListener('click', function (e) {
          var b = e.target.closest('[data-ms-ir]'); if (b) self.irA(Number(b.dataset.msIr));
        });
        this.querySelector('[data-ms-prev]').addEventListener('click', function () { self.irA(self.slideActual - 1); });
        this.querySelector('[data-ms-next]').addEventListener('click', function () { self.irA(self.slideActual + 1); });
        window.addEventListener('resize', function () { self.ajustarAlto(); }, { passive: true });
        track.addEventListener('load', function () { self.ajustarAlto(); }, true);
        var t;
        track.addEventListener('scroll', function () {
          clearTimeout(t);
          t = setTimeout(function () { self.marcarSlide(Math.round(track.scrollLeft / Math.max(1, track.clientWidth))); }, 60);
        }, { passive: true });
      }
    }
    irA(i) {
      var track = this.querySelector('[data-ms-track]');
      i = Math.max(0, Math.min(this.slides.length - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
      this.marcarSlide(i);
    }
    // el visor toma el alto de la foto activa (el par es apaisado, las fotos sueltas verticales)
    ajustarAlto() {
      var track = this.querySelector('[data-ms-track]');
      var sl = track && track.children[this.slideActual || 0];
      if (sl && sl.offsetHeight) track.style.height = sl.offsetHeight + 'px';
    }
    marcarSlide(i) {
      this.slideActual = i;
      this.ajustarAlto();
      var n = this.slides ? this.slides.length : 1;
      var cont = this.querySelector('[data-ms-contador]');
      cont.textContent = n > 1 ? (i + 1) + '/' + n : '';
      this.querySelector('[data-ms-prev]').disabled = i <= 0;
      this.querySelector('[data-ms-next]').disabled = i >= n - 1;
      var thumbs = this.querySelector('[data-ms-thumbs]');
      Array.prototype.forEach.call(thumbs.children, function (b, k) {
        if (k === i) {
          b.setAttribute('aria-current', 'true');
          // mover solo la columna de miniaturas, nunca la página
          if (thumbs.scrollHeight > thumbs.clientHeight) {
            var arriba = b.offsetTop - thumbs.offsetTop, abajo = arriba + b.offsetHeight;
            if (arriba < thumbs.scrollTop) thumbs.scrollTop = arriba;
            else if (abajo > thumbs.scrollTop + thumbs.clientHeight) thumbs.scrollTop = abajo - thumbs.clientHeight;
          }
        }
        else b.removeAttribute('aria-current');
      });
    }

    renderPrecio() {
      var self = this, total = 0, comp = 0, completo = true;
      this.piezas.forEach(function (pz) {
        var v = self.variante(pz);
        if (!v) {
          completo = false;
          var del = pz.prod.variantes.filter(function (x) { return norm(x.c) === norm(pz.color) && x.ok; });
          if (!del.length) del = pz.prod.variantes;
          v = del.reduce(function (m, x) { return x.p < m.p ? x : m; });
        }
        total += v.p; comp += (v.cp > v.p ? v.cp : v.p);
      });
      // 30-oct-2026: precio de oferta del conjunto (lo cobra el descuento automático "Precio conjunto").
      var oferta = Number(this.data.precioConjunto) || 0;
      if (oferta > 0 && oferta < total) {
        this.$precio.innerHTML = '<span class="ms-conj__badge">Oferta conjunto</span> ' + fmt(oferta) + ' <s>' + fmt(comp > total ? comp : total) + '</s>';
        this.total = oferta;
        return;
      }
      this.$precio.innerHTML = (completo ? '' : '<span class="ms-conj__desde">Desde </span>') + fmt(total) + (comp > total ? ' <s>' + fmt(comp) + '</s>' : '');
      this.total = total;
    }

    renderCTA() {
      var faltan = this.piezas.filter(function (pz) { return !pz.talla; });
      var listo = !faltan.length;
      this.$cta.disabled = !listo;
      this.$cta.setAttribute('aria-disabled', String(!listo));
      if (listo) this.$ctaTxt.textContent = 'Agregar conjunto · ' + fmt(this.total);
      else if (faltan.length === 2) this.$ctaTxt.textContent = 'Selecciona tallas';
      else this.$ctaTxt.textContent = 'Selecciona talla de ' + faltan[0].rolLabel.toLowerCase();
    }

    /* ---------- carro ---------- */
    agregar() {
      var self = this;
      var items = this.piezas.map(function (pz) { return self.variante(pz); });
      if (items.some(function (v) { return !v || !v.ok; })) return;
      var handle = this.dataset.handle;
      var payload = { items: items.map(function (v) { return { id: v.id, quantity: 1, properties: { _conjunto: handle } }; }) };
      var drawer = document.querySelector('cart-drawer');
      if (drawer && drawer.getSectionsToRender) {
        payload.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
        payload.sections_url = location.pathname;
      }
      this.$err.hidden = true;
      this.$cta.disabled = true;
      this.$ctaTxt.textContent = 'Agregando…';

      fetch(((window.routes && routes.cart_add_url) || '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(payload)
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) throw new Error(res.description || res.message || 'No se pudo agregar');
          try { if (window.publish && window.PUB_SUB_EVENTS) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ms-conjunto', cartData: res }); } catch (e) {}
          try { document.dispatchEvent(new CustomEvent('ms:conjunto-agregado', { detail: { handle: handle, items: payload.items } })); } catch (e) {}
          if (drawer && res.sections) {
            drawer.classList.remove('is-empty');
            drawer.renderContents({ id: items[0].id, sections: res.sections });
          } else {
            location.href = (window.routes && routes.cart_url) || '/cart';
          }
        })
        .catch(function (e) {
          self.$err.textContent = e.message || 'No se pudo agregar el conjunto. Intenta de nuevo.';
          self.$err.hidden = false;
        })
        .finally(function () { self.renderCTA(); });
    }
  }

  customElements.define('ms-conjunto', MsConjunto);
})();